import { render, staticRenderFns } from "./TranscribeTokenEditorMenu.vue?vue&type=template&id=824d598c&scoped=true&"
import script from "./TranscribeTokenEditorMenu.vue?vue&type=script&lang=js&"
export * from "./TranscribeTokenEditorMenu.vue?vue&type=script&lang=js&"
import style0 from "./TranscribeTokenEditorMenu.vue?vue&type=style&index=0&id=824d598c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "824d598c",
  null
  
)

export default component.exports